export const INDUSTRIES = {
  roofing: {
    name: "Roofing", slug: "roofing",
    headline: "RUN YOUR ROOFING COMPANY WITHOUT THE SPREADSHEETS, TEXTS AND DAILY FIRE DRILLS.",
    sub: "Leads, estimates, jobs, crews, materials, deliveries, equipment, photos and completion, everyone knows what happens next.",
    problems: [
      "Estimates sit in a rep's inbox while the homeowner goes with a competitor",
      "Crews roll up without shingles because nobody checked the delivery",
      "Supplements and change orders live in text threads nobody can find",
      "Completed roofs wait days for final photos before you can invoice"],
    workflow: ["Lead captured", "Estimate & quote", "Quote accepted", "Material order",
      "Delivery confirmed", "Crew scheduled", "Tear-off & install", "Photo completion", "Ready to invoice"],
    features: [
      ["Weather flags", "Weather-sensitive jobs flagged before the crew rolls"],
      ["Material readiness", "Jobs can't go READY until materials are delivered and staged"],
      ["Photo completion", "Before/after photos required before a job can close"],
      ["Crew & equipment scheduling", "Conflict warnings before you double-book the lift"]],
    faqs: [
      ["Does it handle storm-season surges?", "Yes, leads flow into a pipeline, quotes convert to jobs in one click, and readiness tells you which jobs can actually run tomorrow."],
      ["Can crews use it on phones?", "My Day is built for the roof: big buttons, checklists, photo capture, directions."],
      ["We use supplier deliveries, not a warehouse.", "Deliver-to-jobsite purchasing and receiving is built in."]],
    cta: "SEE A ROOFING DEMO",
    seoTitle: "Roofing Business Software | Estimates, Crews & Jobs",
    seoDescription: "Roofing company software to manage leads, estimates, crew scheduling, material deliveries and completion photos in one place. Close jobs faster and invoice sooner.",
    keywords: "roofing business software, roofing CRM, roofing estimate software, roofing crew scheduling, roofing job management software, roofing company app"},
  hvac: {
    name: "HVAC & Refrigeration", slug: "hvac",
    headline: "SERVICE CALLS, INSTALLS AND MAINTENANCE, ONE SYSTEM, NO DISPATCH CHAOS.",
    sub: "Technicians, parts, vehicle stock, maintenance agreements and completion reports, all connected.",
    problems: [
      "Techs drive back to the shop for a part that was on another truck",
      "Maintenance agreements lapse because renewals aren't tracked",
      "Emergency calls blow up the day's schedule with no conflict visibility",
      "Office can't bill until the tech drops off paper tickets"],
    workflow: ["Service call intake", "Diagnosis & quote", "Parts check", "Dispatch",
      "On-site work", "Completion report", "Ready to invoice"],
    features: [
      ["Vehicle inventory", "Track stock per truck; transfers are logged"],
      ["Recurring maintenance", "Agreements auto-generate visits on your schedule"],
      ["Technician My Day", "Arrival, checklists, photos and notes from the field"],
      ["Completion reports", "Digital sign-off before leaving the site"]],
    faqs: [
      ["Does it work for both service and install?", "Yes, different job types carry different workflows, checklists and readiness rules."],
      ["Can it track refrigerant or parts per truck?", "Vehicle locations with on-hand/reserved quantities and transfers are built in."]],
    cta: "SEE AN HVAC DEMO",
    seoTitle: "HVAC Service Software | Dispatch, Parts & Maintenance",
    seoDescription: "HVAC and refrigeration software for dispatch, truck inventory, maintenance agreements and digital completion reports. Run service, installs and PM from one system.",
    keywords: "HVAC software, HVAC dispatch software, HVAC service software, HVAC maintenance agreement software, refrigeration service management, HVAC field service app"},
  plumbing: {
    name: "Plumbing", slug: "plumbing",
    headline: "FROM EMERGENCY CALL TO PAID INVOICE WITHOUT THE PHONE TAG.",
    sub: "Dispatch, parts, job notes, photos and approvals, every call tracked from ring to receipt.",
    problems: [
      "Emergency jobs get scribbled on paper and details are lost by noon",
      "Techs quote one price on site and the office invoices another",
      "Parts runs waste hours because stock isn't visible",
      "Customers call asking where the tech is"],
    workflow: ["Call intake", "Triage & quote", "Parts readiness", "Dispatch",
      "Work + photos", "Customer sign-off", "Invoice ready"],
    features: [
      ["Fast intake", "New call to dispatched job in under a minute"],
      ["Parts readiness", "Jobs show AT RISK until required parts are available"],
      ["Customer confirmation", "Customers confirm appointments from a secure link"],
      ["Site history", "Every visit, note and photo on the customer record"]],
    faqs: [
      ["Can techs see site history on the way?", "Yes, notes, photos and previous work are on the job in My Day."],
      ["Flat-rate or time-and-materials?", "Quotes support line items either way."]],
    cta: "SEE A PLUMBING DEMO",
    seoTitle: "Plumbing Software | Dispatch, Jobs & Invoicing",
    seoDescription: "Plumbing business software for fast call intake, dispatch, parts readiness, customer confirmations and invoicing. Track every job from emergency call to paid invoice.",
    keywords: "plumbing software, plumbing dispatch software, plumbing business management software, plumber scheduling software, plumbing invoicing software, plumbing service app"},
  electrical: {
    name: "Electrical", slug: "electrical",
    headline: "RUN ELECTRICAL SERVICE AND PROJECT WORK FROM ONE BOARD.",
    sub: "Service calls, rough-in/trim phases, permits tracking via checklists, and certified completion documentation.",
    problems: [
      "Rough-in and trim phases get out of sync with the GC's schedule",
      "Inspection prep is a checklist in someone's truck",
      "Materials for multi-day projects aren't staged when the crew arrives",
      "Completion documentation is scattered across photos and paper"],
    workflow: ["Estimate", "Material staging", "Rough-in scheduled", "Rough-in + inspection checklist",
      "Trim & finish", "Completion documents", "Ready to bill"],
    features: [
      ["Phase-based workflows", "Multi-stage job types for rough-in/trim projects"],
      ["Inspection checklists", "Required before a phase can be marked complete"],
      ["Staged materials", "Pick lists per phase so crews leave with everything"],
      ["Documented completion", "Photos, signatures and forms attached to every job"]],
    faqs: [
      ["Does it replace our estimating tool?", "It covers quotes and operational flow; detailed takeoff estimating stays in your estimating tool."],
      ["Apprentices too?", "Role-based access means apprentices see their day, not your margins."]],
    cta: "SEE AN ELECTRICAL DEMO",
    seoTitle: "Electrical Contractor Software | Service & Projects",
    seoDescription: "Electrical contractor software for service calls, rough-in and trim phases, inspection checklists and documented completion. Run service and project work from one board.",
    keywords: "electrical contractor software, electrician software, electrical service software, electrical project management software, electrical job scheduling, electrician field app"},
  restoration: {
    name: "Restoration", slug: "restoration",
    headline: "WATER, FIRE AND MOLD JOBS DOCUMENTED FROM FIRST CALL TO FINAL SIGN-OFF.",
    sub: "Emergency response, drying logs via recurring visits, photo documentation and completion packages.",
    problems: [
      "Insurance documentation is incomplete because photos weren't organized",
      "Multi-day drying visits fall off the calendar",
      "Equipment (dehus, air movers) isn't tracked per site",
      "Scope changes mid-job never make it to the invoice"],
    workflow: ["Emergency intake", "Mitigation & containment", "Drying visits (recurring)",
      "Equipment pickup", "Rebuild scope", "Completion package", "Ready to bill"],
    features: [
      ["Recurring site visits", "Daily drying checks auto-generated until done"],
      ["Equipment on site", "Track which units are at which property"],
      ["Photo categories", "Damage, during and after photos organized automatically"],
      ["Additional work approvals", "Scope changes routed to management before work continues"]],
    faqs: [
      ["Can adjusters get documentation?", "Completion packages with photos and forms export cleanly."],
      ["Overnight emergency calls?", "Intake to dispatched crew in minutes, with the on-call schedule visible."]],
    cta: "SEE A RESTORATION DEMO",
    seoTitle: "Restoration Software | Water, Fire & Mold Jobs",
    seoDescription: "Restoration software for emergency intake, recurring drying visits, equipment tracking and photo documentation. Build insurance-ready completion packages fast.",
    keywords: "restoration software, water damage restoration software, fire restoration software, mold remediation software, restoration job management, restoration company app"},
  landscaping: {
    name: "Landscaping", slug: "landscaping",
    headline: "MOW ROUTES, ENHANCEMENTS AND INSTALLS, SCHEDULED WITHOUT THE WHITEBOARD.",
    sub: "Recurring maintenance routes, seasonal work, crews, equipment and materials in one place.",
    problems: [
      "Weekly routes break when someone calls in sick",
      "Enhancement quotes never turn into scheduled work",
      "The skid steer is booked on two sites at once",
      "Customers want proof the crew actually came"],
    workflow: ["Recurring route setup", "Weekly auto-generation", "Crew assignment",
      "On-site completion + photos", "Enhancement quote", "Scheduled install", "Invoiced"],
    features: [
      ["Recurring routes", "M/W/F or any pattern, visits generate automatically"],
      ["Crews & equipment", "Assign people and machines with conflict warnings"],
      ["Proof of visit", "Timestamps and photos on every stop"],
      ["Enhancement pipeline", "Quotes convert to scheduled installs in one click"]],
    faqs: [
      ["Seasonal contracts?", "Recurring rules with start/end dates handle seasons."],
      ["Does it do route optimization?", "It schedules and dispatches; hard route optimization is on the roadmap."]],
    cta: "SEE A LANDSCAPING DEMO",
    seoTitle: "Landscaping Software | Routes, Crews & Scheduling",
    seoDescription: "Landscaping business software for recurring maintenance routes, crew and equipment scheduling, proof of visit and enhancement quoting. Schedule without the whiteboard.",
    keywords: "landscaping software, lawn care software, landscape scheduling software, landscaping crew management, recurring route scheduling, landscaping business app"},
  cleaning: {
    name: "Cleaning", slug: "cleaning",
    headline: "COMMERCIAL AND RESIDENTIAL CLEANING WITHOUT THE NIGHTLY CHECK-IN CALLS.",
    sub: "Recurring contracts, checklists per site, proof of service and issue reporting from every cleaner.",
    problems: [
      "You find out a site was missed when the client calls",
      "Every building has different requirements kept in a binder",
      "Quality issues surface weeks later in a bad review",
      "New cleaners don't know site-specific instructions"],
    workflow: ["Contract setup", "Recurring schedule", "Cleaner checklists per site",
      "Issue reporting", "Quality review", "Client-ready completion"],
    features: [
      ["Site checklists", "Each location's exact requirements on the cleaner's phone"],
      ["Proof of service", "Arrival times and completion photos per visit"],
      ["Issue reporting", "Broken fixture? Reported with a photo before you hear it from the client"],
      ["No inventory bloat", "Enable only what cleaning actually needs"]],
    faqs: [
      ["Do cleaners need training to use it?", "If they can use a phone camera, they can use My Day."],
      ["Per-client instructions?", "Persistent site instructions show on every visit."]],
    cta: "SEE A CLEANING DEMO",
    seoTitle: "Cleaning Business Software | Contracts & Checklists",
    seoDescription: "Commercial and residential cleaning software for recurring contracts, site checklists, proof of service and issue reporting. Know every site was cleaned, on time.",
    keywords: "cleaning business software, janitorial software, commercial cleaning software, cleaning company scheduling software, proof of service software, cleaning crew app"},
  construction: {
    name: "Construction", slug: "construction",
    headline: "KEEP EVERY PROJECT MOVING WITHOUT CHASING SUBS AND SUPPLIERS BY PHONE.",
    sub: "Phases, subcontractors, material deliveries, equipment and documented progress on every job.",
    problems: [
      "Subs show up before materials and burn a day",
      "Change orders agreed verbally and forgotten at billing",
      "Progress photos are in twelve different camera rolls",
      "Nobody knows which phase is actually blocked and why"],
    workflow: ["Estimate & contract", "Phase planning", "Material/sub readiness",
      "Phase execution", "Progress documentation", "Change orders reviewed", "Completion & billing"],
    features: [
      ["Readiness engine", "A phase shows BLOCKED until materials, subs and equipment line up"],
      ["Subcontractor records", "Trades, contacts and requirements in one directory"],
      ["Change management", "Additional work requests reviewed before they become free work"],
      ["Progress timeline", "Photos, notes and status in one auditable feed"]],
    faqs: [
      ["Does it do estimating or accounting?", "No, it runs operations. It complements your accounting tools instead of replacing them."],
      ["Multiple concurrent projects?", "The Command Centre shows risk across all of them at once."]],
    cta: "SEE A CONSTRUCTION DEMO",
    seoTitle: "Construction Management Software | Projects & Subs",
    seoDescription: "Construction operations software for phase planning, subcontractor coordination, material readiness, change orders and progress documentation across every project.",
    keywords: "construction management software, construction project management software, subcontractor management software, construction scheduling software, change order tracking, construction field app"},
  painting: {
    name: "Painting", slug: "painting",
    headline: "ESTIMATE TO FINAL WALKTHROUGH WITHOUT THE MISSED PREP STEPS.",
    sub: "Fast quoting, crew scheduling, color/spec documentation, punch lists and completion photos.",
    problems: [
      "Crews arrive without the right paint or sheen",
      "Prep steps get skipped under time pressure",
      "Punch-list items live in the customer's text messages",
      "Final walkthrough sign-off isn't documented"],
    workflow: ["Estimate", "Color/spec confirmation", "Materials ordered", "Crew scheduled",
      "Prep checklist", "Paint + daily photos", "Walkthrough & sign-off"],
    features: [
      ["Spec sheets on the job", "Colors, sheens and surfaces attached to the work order"],
      ["Prep checklists", "Required before the job can start"],
      ["Customer sign-off", "Digital signature at the final walkthrough"],
      ["Punch list tracking", "Issues logged and resolved with photo proof"]],
    faqs: [
      ["Interior and exterior workflows?", "Job types carry their own checklists and readiness rules."],
      ["Small crew, is this overkill?", "Start with jobs, schedule and photos; turn modules on as you grow."]],
    cta: "SEE A PAINTING DEMO",
    seoTitle: "Painting Business Software | Quotes, Crews & Punch Lists",
    seoDescription: "Painting contractor software for fast quotes, crew scheduling, color and spec sheets, prep checklists, punch lists and completion sign-off. Stop missed prep steps.",
    keywords: "painting business software, painting contractor software, painter scheduling software, painting estimate software, punch list tracking software, painting company app"},
  "property-maintenance": {
    name: "Property Maintenance", slug: "property-maintenance",
    headline: "EVERY WORK ORDER FROM TENANT REQUEST TO VERIFIED FIX.",
    sub: "Intake, triage, vendor and tech dispatch, recurring preventive work, and completion proof per property.",
    problems: [
      "Tenant requests arrive by text, email and voicemail with no queue",
      "Preventive maintenance schedules slip silently",
      "Vendors invoice for work nobody verified",
      "Property managers can't see status without calling you"],
    workflow: ["Request intake", "Triage & priority", "Tech/vendor dispatch",
      "Work + photo proof", "Verification", "Property report"],
    features: [
      ["Work order queue", "Every request triaged with priority and status"],
      ["Preventive schedules", "Recurring inspections and service auto-generated"],
      ["Vendor coordination", "Subcontractor dispatch with the same visibility"],
      ["Per-property history", "Every visit, photo and note by unit or building"]],
    faqs: [
      ["Can tenants submit requests?", "The customer portal covers status and messages; request intake links are on the roadmap."],
      ["Multiple properties per client?", "Sites and job history are tracked per location."]],
    cta: "SEE A MAINTENANCE DEMO",
    seoTitle: "Property Maintenance Software | Work Orders & PM",
    seoDescription: "Property maintenance software for work order intake, triage, tech and vendor dispatch, recurring preventive maintenance and per-property completion proof.",
    keywords: "property maintenance software, work order software, facility maintenance software, preventive maintenance scheduling software, property management maintenance, maintenance work order app"},
  mechanic: {
    name: "Mechanic & Auto Repair", slug: "mechanic",
    headline: "RUN YOUR REPAIR SHOP WITHOUT LOST TICKETS, PARTS DELAYS AND APPROVAL PHONE TAG.",
    sub: "Repair orders, digital inspections, parts, bay scheduling, technician time and invoicing, every vehicle tracked from drop-off to pickup.",
    problems: [
      "Repair orders on paper get lost between the counter and the bays",
      "Techs wait on parts because nobody checked stock before the job started",
      "Customers approve work slowly because the estimate is stuck on a phone call",
      "Finished vehicles sit because the invoice isn't ready at pickup"],
    workflow: ["Appointment", "Vehicle checked in", "Digital inspection", "Estimate sent",
      "Customer approved", "Parts staged", "Repair", "Quality check", "Ready for pickup", "Invoiced"],
    features: [
      ["Digital repair orders", "Every vehicle, concern, VIN and mileage on one live ticket"],
      ["Inspection & photo approval", "Send the estimate with photos; get approval before work starts"],
      ["Parts readiness", "Jobs can't start until the parts are in and staged"],
      ["Bay & technician scheduling", "See bay load and tech hours before you promise a time"]],
    faqs: [
      ["Can we track each customer's vehicle?", "Yes, every repair order carries the vehicle, VIN, mileage and full service history."],
      ["Does it send estimates for approval?", "Build an estimate with photos and send it; approval and signature are captured before the work proceeds."],
      ["Can techs clock time to each job?", "Yes, technician time tracks to the repair order and flows into job costing and payroll."]],
    cta: "SEE A MECHANIC SHOP DEMO",
    seoTitle: "Auto Repair Shop Software | Repair Orders & Estimates",
    seoDescription: "Mechanic and auto repair shop software for digital repair orders, inspections, estimate approvals, parts, bay scheduling and invoicing. Track every vehicle from drop-off to pickup.",
    keywords: "auto repair shop software, mechanic shop software, repair order software, automotive shop management software, auto shop estimate software, mechanic business app"},
  "fleet-management": {
    name: "Fleet Management", slug: "fleet-management",
    headline: "KEEP EVERY TRUCK IN SERVICE WITHOUT MISSED PMs, FAILED INSPECTIONS AND SURPRISE BREAKDOWNS.",
    sub: "Work orders, preventive maintenance schedules, DOT compliance, parts and service history, every vehicle and trailer tracked in one system.",
    problems: [
      "Preventive maintenance slips because PM schedules live in a spreadsheet nobody updates",
      "Trucks fail inspections because registration and compliance dates sneak up",
      "Downtime drags on while parts and techs get sorted out",
      "True cost per vehicle is impossible to see across repairs and fuel"],
    workflow: ["Request / fault", "Triaged", "Scheduled", "Parts staged", "In service",
      "Road test", "Completed", "Billed / costed"],
    features: [
      ["PM schedules by km, hours or date", "Auto-generated work orders before a unit is due"],
      ["Licensing & compliance alerts", "Registration, insurance, inspections and driver licences tracked with reminders"],
      ["Full service history per unit", "Every repair, part and cost against each vehicle and trailer"],
      ["Cost per vehicle", "See total maintenance spend by unit so you know what to retire"]],
    faqs: [
      ["Does it handle preventive maintenance?", "Yes, PM intervals by km, hours or calendar auto-create work orders before each unit comes due."],
      ["Can it track DOT compliance?", "Registration, insurance, inspections and driver licences are tracked with expiry reminders."],
      ["In-house and outsourced repairs?", "Track both: internal technician work orders and outside vendor repairs against the same vehicle history."]],
    cta: "SEE A FLEET MANAGEMENT DEMO",
    seoTitle: "Fleet Maintenance Software | PM, Work Orders & DOT",
    seoDescription: "Fleet management and maintenance software for preventive maintenance schedules, work orders, DOT compliance, parts and per-vehicle service history and costs. Keep every unit in service.",
    keywords: "fleet maintenance software, fleet management software, preventive maintenance software, DOT compliance software, fleet work order software, vehicle maintenance tracking"},
  "tire-shop": {
    name: "Tire Shop", slug: "tire-shop",
    headline: "RUN THE TIRE SEASON WITHOUT MIXED-UP ORDERS, STOCK-OUTS AND PICKUP CHAOS.",
    sub: "Work orders, tire inventory, seasonal swaps, bay scheduling and fast invoicing, every vehicle in and out without the counter chaos.",
    problems: [
      "The seasonal rush turns into chaos with handwritten tickets and no bay plan",
      "You lose sales because the size the customer needs isn't in stock",
      "Storage swaps get mismatched to the wrong customer or vehicle",
      "Cars pile up at pickup while someone writes the invoice by hand"],
    workflow: ["Appointment", "Vehicle in", "Estimate", "Approved", "Tires staged",
      "Install", "Balance & torque", "Ready for pickup", "Invoiced"],
    features: [
      ["Tire inventory by size & brand", "Know what's in stock before you promise the customer"],
      ["Seasonal swap & storage", "Track stored sets by customer and vehicle, recall them next season"],
      ["Work orders & inspection", "Tread depth, pressure and torque captured on every ticket"],
      ["Bay scheduling", "Book the rush without double-booking a hoist"]],
    faqs: [
      ["Can we track stored winter tires?", "Yes, stored sets are tracked by customer and vehicle so recall next season is one search."],
      ["Does it manage tire stock?", "Inventory tracks tires by size and brand with purchasing and receiving built in."],
      ["Handle the seasonal rush?", "Appointments and bay scheduling keep the swap season flowing without a paper pile."]],
    cta: "SEE A TIRE SHOP DEMO",
    seoTitle: "Tire Shop Software | Work Orders, Inventory & Scheduling",
    seoDescription: "Tire shop software for work orders, tire inventory by size and brand, seasonal swaps and storage, bay scheduling and fast invoicing. Run the tire season without the counter chaos.",
    keywords: "tire shop software, tire store software, tire shop management software, tire inventory software, seasonal tire storage software, tire shop scheduling"},
};

export const INDUSTRY_LIST = Object.values(INDUSTRIES);
